<section class="landing-inversores__final-cta">
  <div class="landing-inversores__container landing-inversores__final-cta-inner">
    <h2 class="landing-inversores__final-cta-title">
      Empieza a cobrar renta desde el
      <span class="landing-inversores__final-cta-highlight">primer día</span>
    </h2>
    <p class="landing-inversores__final-cta-lead">
      Reserva tu Asesoría Gratuita y te mostramos pisos en exclusiva, ya alquilados y con rentabilidad verificada.
    </p>
    <a
      class="landing-inversores__button landing-inversores__button--large landing-inversores__button--primary landing-inversores__final-cta-button"
      [href]="advisoryBookingUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      Reserva tu Asesoría Gratuita
    </a>
    <p class="landing-inversores__final-cta-note">Sin ningún compromiso</p>
  </div>
</section>
